import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import StopCircleIconSvg from './icon-stop-circle.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <StopCircleIconSvg {...validProps} />;
}
SvgComponent.iconName = 'stop-circleIcon';

/**
 * @deprecated This is a legacy icon
 */
export const StopCircleIcon = svgIconWrapper(SvgComponent);
